import { render, staticRenderFns } from "./MembersPointSection.vue?vue&type=template&id=ca41259c&scoped=true"
import script from "./MembersPointSection.vue?vue&type=script&lang=ts"
export * from "./MembersPointSection.vue?vue&type=script&lang=ts"
import style0 from "./MembersPointSection.vue?vue&type=style&index=0&id=ca41259c&prod&lang=scss&scoped=true"
import style1 from "./MembersPointSection.vue?vue&type=style&index=1&id=ca41259c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca41259c",
  null
  
)

export default component.exports